<template>
  <v-card
    xs12
    flat
    tile
    height="100%"
    class="d-flex flex-column justify-space-between"
  >
    <v-card flat>
      <v-list
        dense
        expand
      >
        <v-subheader>Anzeigeeinstellungen</v-subheader>
        <v-divider />

        <!-- select ags & update -->
        <v-list-item
          id="sh-step-1"
          class="mt-3"
        >
          <v-select
            v-model="agsId"
            :items="ags"
            label="Stadt/Gemeinde/Landkreis"
            item-value="agsId"
            item-text="name"
            dense
            :menu-props="{contentClass: 'shepherdHelperClass1'}"
            @click="$store.commit('nextStep')"
          />
        </v-list-item>
        <v-list-item id="sh-step-2">
          <v-select
            v-model="updateId"
            :items="updatesFilteredByAgs"
            label="Szenario"
            item-value="updateId"
            :menu-props="{contentClass: 'shepherdHelperClass2'}"
            :item-text="
              item =>
                item.dateCreated
                  ? `${item.description} - ${new Date(
                    item.dateCreated
                  ).toLocaleDateString('de-DE')}`
                  : item.description
            "
            dense
            @click="$store.commit('nextStep')"
          >
            <template
              v-if="updateId"
              v-slot:append-outer
            >
              <v-tooltip
                v-if="selectedUpdate.updateStatus == 'editing'"
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="berechnungsparameter-anpassen"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="updateDialog = { show: true, mode: 'edit' }; $store.commit('berechnungsparameterAnpassen');"
                  >
                    <v-icon color="#8B008B">
                      fa-cog
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  Berechnungsparameter anpassen
                </span>
              </v-tooltip>
              <v-tooltip
                v-else
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="berechnungsparameter-anpassen"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="updateDialog = { show: true, mode: 'info' }; $store.commit('berechnungsparameterAnpassen');"
                  >
                    <v-icon color="blue">
                      fa-info
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  Berechnungsparameter anzeigen
                </span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="showConfirmUpdateCreationDialog = true"
                  >
                    <v-icon>fa-plus</v-icon>
                  </v-btn>
                </template>
                <span>
                  Neues Szenario aus Bestehendem erstellen
                </span>
              </v-tooltip>
            </template>
          </v-select>
        </v-list-item>
        <v-list-item
          v-if="selectedUpdate && selectedUpdate.updateStatus == 'editing'"
        >
          <v-btn
            id="zur-berechnung-freigeben"
            outlined
            color="#8B008B"
            class="mb-3"
            style="width: 100%;"
            :loading="patchUpdateStatusReadyForCalcLoading"
            @click="showConfirmPatchUpdateStatusReadyToCalcDialog = true"
          >
            zur Berechnung freigeben
          </v-btn>
        </v-list-item>
        <v-list-item
          v-if="
            selectedUpdate &&
              selectedUpdate.updateStatus == 'ready_for_calculation'
          "
        >
          <v-alert
            elevation="2"
            border="top"
            colored-border
            type="info"
            color="grey"
          >
            Das Szenario wurde zur Berechnung freigegeben und wird innerhalb der
            nächsten Woche berechnet. Sie werden per E-Mail benachrichtigt, wenn die Berechnung
            abgeschlossen ist.
          </v-alert>
        </v-list-item>
        <v-list-item
          v-if="
            selectedUpdate && selectedUpdate.updateStatus == 'now_calculating'
          "
        >
          <v-alert
            elevation="2"
            border="top"
            colored-border
            type="info"
            color="grey"
          >
            Das Szenario wird gerade berechnet.
          </v-alert>
        </v-list-item>
        <v-list-item v-if="error">
          <v-alert
            elevation="2"
            border="top"
            colored-border
            type="error"
          >
            Die Aktion konnte nicht durchgeführt werden. Bitte versuchen Sie es
            erneut.
          </v-alert>
        </v-list-item>
        <v-divider />
        <template
          v-if="selectedUpdate && selectedUpdate.updateStatus == 'calculated'"
        >
          <!-- Heat map layers -->
          <v-list-group
            id="sh-step-3"
            prepend-icon="fa-map"
          >
            <template #activator>
              <v-list-item-title id="sh-click-2">
                Flächenebenen
              </v-list-item-title>
            </template>
            <v-list-item-group
              v-model="selectedTileLayer"
              active-class="selected-tile-layer-border"
            >
              <v-list-item
                v-for="tileLayerType in tileLayerTypes"
                :id="tileLayerType.layertypesId"
                :key="tileLayerType.layertypesId"
              >
                <v-list-item-title>
                  {{ tileLayerType.description }}
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-divider />
          <!-- Point layers -->
          <v-list-group prepend-icon="fa-layer-group">
            <template #activator>
              <v-list-item-title id="sh-click-3">
                Punktebenen
              </v-list-item-title>
            </template>
            <v-list-item-group
              v-model="selectedPointLayers"
              multiple
              color="indigo"
            >
              <v-list-item
                v-for="pointLayerType in pointLayerTypes"
                :id="pointLayerType.layertypesId"
                :key="pointLayerType.layertypesId"
                :color="pointLayerType.color"
              >
                <template #default="{ active }">
                  <v-list-item-title>
                    {{ pointLayerType.description }}
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      :color="pointLayerType.color"
                    />
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
          <v-divider />
        </template>

        <template v-if="selectedAgs && selectedAgs.agsGeo">
          <!-- Geo input layers-->
          <v-list-group
            id="sh-step-4"
            prepend-icon="fa-map-marker"
          >
            <template #activator>
              <v-list-item-title id="sh-click-1">
                Open Street Map Ebenen
              </v-list-item-title>
            </template>
            <v-list-item-group
              v-model="selectedGeoInputLayers"
              multiple
            >
              <v-list-item
                v-for="geoInputType in geoInputTypes"
                :key="geoInputType.geoInputId"
                :color="geoInputType.color"
              >
                <template #default="{ active }">
                  <v-list-item-title>
                    {{ geoInputType.geoInputType }}
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      :color="geoInputType.color"
                    />
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
          <v-divider />
        </template>
      </v-list>
    </v-card>

    <!-- Year selection/display -->
    <v-card
      id="sh-step-5"
      flat
    >
      <v-divider />
      <v-slider
        v-if="updateYears.length > 1"
        v-model="yearSelectIndex"
        prepend-icon="fa-calendar"
        :max="updateYears.length - 1"
        :tick-labels="yearSliderTickLabels"
        thumb-label="always"
        step="1"
        ticks="always"
        tick-size="7"
        class="pa-3 pt-10"
        @mouseup="selectedYearChange"
      >
        <template v-slot:thumb-label="{ value }">
          {{ updateYears[value] }}
        </template>
      </v-slider>
      <!-- if num years == 1, show year as text
           if num yars == 0, show icon only -->
      <v-text-field
        v-else
        prepend-icon="fa-calendar"
        :value="updateYears.length == 1 ? updateYears[0] : ''"
        solo
        flat
        readonly
        class="pa-3 pt-4"
      />
    </v-card>
    <UpdateSettingsDialog
      :show-dialog="updateDialog.show"
      :mode="updateDialog.mode"
      @close="updateDialog = { show: false, mode: null }"
    />
    <CreateUpdateDialog
      v-model="showConfirmUpdateCreationDialog"
      @updateCreated="updateId = $event"
    />
    <!-- "Szenario zur Berechung freigeben" confirmation dialog-->
    <v-dialog
      v-model="showConfirmPatchUpdateStatusReadyToCalcDialog"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <h3>Vorgang bestätigen</h3>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn
                icon
                @click="showConfirmPatchUpdateStatusReadyToCalcDialog = false"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-alert
            elevation="2"
            border="top"
            colored-border
            class="mt-3"
            type="warning"
          >
            <p>
              Das Szenario wird zur Berechnung freigegeben und innerhalb der nächsten Woche berechnet.
              Die Eingangsparameter können nach der Freigabe nicht mehr angepasst werden.
              Sie werden per E-Mail benachrichtigt, wenn die Berechnung abgeschlossen ist.
            </p>
            <p>Wollen Sie fortfahren?</p>
          </v-alert>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-center">
          <v-btn
            class="my-3"
            color="primary"
            @click="patchUpdateStatusReadyForCalc"
          >
            Szenario zur Berechnung freigeben
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UpdateSettingsDialog from "@/components/dialogs/updateSettingsDialog/UpdateSettingsDialog";
import CreateUpdateDialog from "@/components/dialogs/CreateUpdateDialog";

import { mapActions, mapGetters } from "vuex";
import stc from "string-to-color";

export default {
  name: "LayerMenu",
  components: { UpdateSettingsDialog, CreateUpdateDialog },
  props: {
    tourUpdateId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      agsId: null,
      updateId: null,
      selectedTileLayer: null,
      selectedHeatMapLayer: null,
      selectedPointLayers: [],
      selectedGeoInputLayers: [],
      yearSelectIndex: 0,
      updateDialog: { show: false, mode: null },
      showConfirmUpdateCreationDialog: false,
      patchUpdateStatusReadyForCalcLoading: false,
      showConfirmPatchUpdateStatusReadyToCalcDialog: false,
      error: null
    };
  },
  computed: {
    ...mapGetters([
      "ags",
      "updatesFilteredByAgs",
      "updateYears",
      "pointLayerTypes",
      "tileLayerTypes",
      "heatMapLayerTypes",
      "geoInputTypes",
      "geoInputIcons",
      "selectedUpdate",
      "selectedAgs",
      "user"
    ]),
    // Set years that are available for chosen updateId.
    updateYears() {
      return this.selectedUpdate && this.selectedUpdate.year
        ? this.updatesFilteredByAgs
          .find(update => update.updateId == this.selectedUpdate.updateId)
          .year.split(",")
        : [];
    },
    yearSliderTickLabels() {
      return this.updateYears.map((elem, i) =>
        i == 0 || i == this.updateYears.length - 1 ? elem : ""
      );
    }
  },
  watch: {
    agsId(newVal) {
      this.updateId = null;
      this.retrieveGeoInputTypes(newVal);
      this.setSelectedAgs({
        selectedAgsId: newVal,
        agsList: this.ags
      });
    },
    updateId(value) {
      // Reset current layers.
      this.setTileLayerTypes([]);
      this.setHeatMapLayerTypes([]);
      this.setPointLayerTypes([]);
      // Get layers that are available for chosen updateId.
      this.retrieveLayerTypes(value);
      this.setSelectedUpdate({
        selectedUpdateId: value,
        updateList: this.updatesFilteredByAgs
      });
      if (!value) {
        this.setSelectedYearIndex(0);
      }
    },
    selectedTileLayer() {
      window.EventBus.$emit("hideTileLayers");
      this.showSelectedTileLayer();
    },
    selectedHeatMapLayer() {
      window.EventBus.$emit("hideHeatMapLayers");
      this.showSelectedHeatMapLayer();
    },
    selectedPointLayers() {
      window.EventBus.$emit("hidePointLayers");
      this.showSelectedPointLayers();
    },
    selectedGeoInputLayers() {
      window.EventBus.$emit("hideGeoInputLayers");
      this.showSelectedGeoInputLayers();
    },
    updateYears(newVal) {
      if (newVal.length == 0) {
        this.yearSelectIndex = 0;
      }
    }
  },
  mounted() {
    window.EventBus.$on("deselectGeoInputLayers", () =>
      this.deselectGeoInputLayers()
    );
    window.EventBus.$on("resetSelectedLayers", () => {
      this.selectedTileLayer = null;
      this.selectedPointLayers = [];
      this.selectedHeatMapLayer = null;
    });
    this.$store.subscribe((mutation) => {
      if(mutation.type === "resetSelectedAgs") {
        this.agsId = null
      }
      if(mutation.type === "resetSelectedUpdate") {
        this.updateId = null
      }
    })

  },
  methods: {
    ...mapActions([
      "setSelectedAgs",
      "setSelectedUpdate",
      "patchUpdate",
      "setSelectedYearIndex",
      "setPointLayerTypes",
      "setTileLayerTypes",
      "setHeatMapLayerTypes",
      "setGeoInputTypes"
    ]),
    // Get layer types for selected updateId.
    retrieveLayerTypes(updateId) {
      var self = this;
      var pointLayerTypes = [];
      var tileLayerTypes = [];
      var heatMapLayerTypes = [];
      $api.get(window.actionUrl + `layertypes/${updateId}`)
        .then(function(res) {
          // Add layers to the corresponding layertype array
          for (let layerType of res.data.layertypes) {
            if (layerType.layerClass === "point") {
              layerType.color = stc(layerType.description);
              pointLayerTypes.push(layerType);
            } else if (layerType.layerClass === "area") {
              tileLayerTypes.push(layerType);
            } else if (layerType.layerClass === "heatmap") {
              heatMapLayerTypes.push(layerType);
            }
          }
          self.setPointLayerTypes(pointLayerTypes);
          self.setTileLayerTypes(tileLayerTypes);
          self.setHeatMapLayerTypes(heatMapLayerTypes);
        });
    },
    // Get set of all geo input types available for selected agsId.
    retrieveGeoInputTypes(agsId) {
      var self = this;
      $api.get(window.actionUrl + `ags/${agsId}/geoInputTypes`)
        .then(function(res) {
          let geoInputTypes = res.data.geoInputTypes.sort(
            (a, b) => a.geoInputType > b.geoInputType
          );
          for (let geoInputType of geoInputTypes) {
            geoInputType.color = stc(geoInputType.geoInputType);
            geoInputType.icon = self.geoInputIcons[geoInputType.geoInputType];
          }
          self.setGeoInputTypes(geoInputTypes);
        });
    },
    // deselect all geo input layers in list (triggered on agsId change)
    deselectGeoInputLayers() {
      this.selectedGeoInputLayers = [];
    },
    // load layers when year changes
    selectedYearChange() {
      window.EventBus.$emit("hideTileLayers");
      window.EventBus.$emit("hideHeatMapLayers");
      window.EventBus.$emit("hidePointLayers");
      this.showSelectedTileLayer();
      this.showSelectedHeatMapLayer();
      this.showSelectedPointLayers();
      this.setSelectedYearIndex(this.yearSelectIndex);
    },
    showSelectedTileLayer() {
      // Check must be against 'null'. Only checking for selectedTileLayer would equal 'false' when it equals 0.
      if (this.selectedTileLayer != null) {
        window.EventBus.$emit(
          "showLayer",
          this.tileLayerTypes[this.selectedTileLayer],
          this.updateYears[this.yearSelectIndex]
        );
      }
    },
    showSelectedHeatMapLayer() {
      // Check must be against 'null'. Only checking for selectedHeatMapLayer would equal 'false' when it equals 0.
      if (this.selectedHeatMapLayer != null) {
        window.EventBus.$emit(
          "showLayer",
          this.heatMapLayerTypes[this.selectedHeatMapLayer],
          this.updateYears[this.yearSelectIndex]
        );
      }
    },
    showSelectedPointLayers() {
      for (let i of this.selectedPointLayers) {
        window.EventBus.$emit(
          "showLayer",
          this.pointLayerTypes[i],
          this.updateYears[this.yearSelectIndex]
        );
      }
    },
    showSelectedGeoInputLayers() {
      for (let i of this.selectedGeoInputLayers) {
        window.EventBus.$emit("showLayer", {
          ...this.geoInputTypes[i],
          layerClass: "geoInput"
        });
      }
    },
    // updateStatus: 'editing' -> 'ready_for_calculation'
    async patchUpdateStatusReadyForCalc() {
      this.error = null;
      this.patchUpdateStatusReadyForCalcLoading = true;
      await $api
        .patch(`update/${this.selectedUpdate.updateId}?client_id=${this.user.clientId}`, {
          updateStatus: "ready_for_calculation"
        })
        .then(res => {
          console.log(res.data.update);
          this.patchUpdate(res.data.update);
        })
        .catch(error => {
          this.error = error;
          console.log(error);
          console.debug(error);
        });
      this.patchUpdateStatusReadyForCalcLoading = false;
      this.showConfirmPatchUpdateStatusReadyToCalcDialog = false;
    }
  }
};
</script>

<style>
.selected-heat-map-layer-border {
  border: 2px dashed orange;
}
</style>
